import './SuperAdminConsole.css';
import AdminPageLayout from '../../components/AdminPageLayout/AdminPageLayout';
import { useUserRolesAndPermissions } from '../../context/UserRolesAndPermissionsContext';
import { DARK, USER_ROLE_KEYS } from '../../utilities/constants';
import { useNotification } from '../../context/NotificationContext';
import { useTheme } from '../../context/ThemeContext';
import { Flex, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as cancel } from '../../assets/icons/cancel.svg';
import { ReactComponent as cancelBlack } from '../../assets/icons/cancel-black.svg';
import { useContext, useEffect } from 'react';
import { ErrorMessageContext } from '../../context/ErrorMessageContext';
import { useCompanyManagement } from '../ExecutiveConsole/components/hooks/useCompanyManagement';

const { Text } = Typography;

const SuperAdminConsole = () => {
  const { userRole } = useUserRolesAndPermissions();
  const { isFirstLoginSession, cancelSuperAdminCompaniesOverviewNotification } =
    useNotification();
  const { pageActiveTabKey } = useCompanyManagement();
  const { addErrorMessage, removeErrorMessage } =
    useContext(ErrorMessageContext);
  const { theme } = useTheme();

  const addSuperAdminCompaniesOverviewNotification = () => {
    if (isFirstLoginSession?.superAdminCompaniesOverview) {
      addErrorMessage(
        <Flex gap={16} align="center">
          <Text>The data shown here is of the last 24 hours.</Text>
          <Icon
            component={theme === DARK ? cancel : cancelBlack}
            onClick={() => {
              removeErrorMessage('super-admin-companies-overview-notification');
              cancelSuperAdminCompaniesOverviewNotification();
            }}
          />
        </Flex>,
        'notify',
        'super-admin-companies-overview-notification'
      );
    }
  };

  useEffect(() => {
    if (pageActiveTabKey === 'companies-overview') {
      addSuperAdminCompaniesOverviewNotification();
    } else {
      removeErrorMessage('super-admin-companies-overview-notification');
    }
  }, [pageActiveTabKey]);

  useEffect(() => {
    if (pageActiveTabKey === 'companies-overview') {
      addSuperAdminCompaniesOverviewNotification();
    }
    return () => {
      removeErrorMessage('super-admin-companies-overview-notification');
    };
  }, [theme]);

  return (
    <AdminPageLayout
      rootPath={
        userRole === USER_ROLE_KEYS.SUPER_ADMIN
          ? '/super-admin-console'
          : '/platform-operations-console'
      }
      className="super-admin-console"
    />
  );
};

export default SuperAdminConsole;
